import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsAddToListLinkStyles {
    wrapper?: InjectableCss;
    link?: ProductAddToListLinkStyles;
}

export const addToListLinkStyles: ProductDetailsAddToListLinkStyles = {
    wrapper: {
        css: css`
            text-align: center;
            display: inline;
            padding-right: 15px;
        `,
    },
};

const styles = addToListLinkStyles;

const ProductDetailsAddToListLink: React.FC<OwnProps> = ({ product, variantSelectionCompleted }) => {
    if (!product.canAddToWishlist && !variantSelectionCompleted) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductAddToListLink data-test-selector="productDetails_addToList" extendedStyles={styles.link} />
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(withProduct(ProductDetailsAddToListLink));
